module.exports = __webpack_public_path__ + "static/media/Collaboration.40a359f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Static/Collaboration.jpg
// module id = 33
// module chunks = 1